import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux'
import FormError from '../partials/FormError';
import { deleteSublocation } from '../../actions/sublocations';
import { destructServerErrors, allErrors } from '../../helpers/error';
import __ from '../../helpers/translation';

const propTypes = {
  sublocation: PropTypes.object,
  onDeleted: PropTypes.func,
};

function SublocationDeleteModal(props) {
   
    const dispatch = useDispatch()

    const [isDeleting, setIsDeleting] = useState(false);
    const [errors, setErrors] = useState('');

    const deleteItem = () => {
        setErrors('');
        setIsDeleting(true);

        dispatch(deleteSublocation(props.sublocation))
            .then(data => {
                setIsDeleting(false);
                window.$('#deleteSublocation').modal('hide');
                props.onDeleted();
            })
            .catch(error => {
                let errors = destructServerErrors(error);
                setErrors(errors ? allErrors(errors).join('') : __('app.inspections.delete_sublocation_error'))
                setIsDeleting(false);
            });
    }

    if(!props.sublocation){
        return '';
    }

    return (

        <div className="modal fade" id="deleteSublocation" tabIndex="-1" role="dialog" aria-labelledby="deleteSublocation" aria-hidden="true">
            <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div className="modal-content p-3 p-sm-5">
                    <div className="modal-header">
                        <h1 className="modal-title fw-600" id="exampleModalLongTitle">{ __('app.inspections.delete_sublocation_title', {sublocation: props.sublocation.name}) }</h1>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        {errors && 
                            (
                                <FormError>{errors}</FormError>
                            )
                        }
                        <button onClick={(e) => deleteItem()}
                            disabled={isDeleting}
                            className="btn btn-black d-block w-100 mt-5">
                            { __('app.general.delete') }
                            {isDeleting && (
                                <i className="far fa-circle-notch fa-spin ml-3"></i>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>

    )
}

SublocationDeleteModal.propTypes = propTypes;

export default SublocationDeleteModal;